import { render } from "./Slider.vue?vue&type=template&id=774b989c&scoped=true&lang=pug"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"

import "./Slider.vue?vue&type=style&index=0&id=774b989c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774b989c"],['__file',"src/common/inputs/Slider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "774b989c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('774b989c', __exports__)) {
    api.reload('774b989c', __exports__)
  }
  
  module.hot.accept("./Slider.vue?vue&type=template&id=774b989c&scoped=true&lang=pug", () => {
    api.rerender('774b989c', render)
  })

}


export default __exports__